import ProductItem from '@/features/common/components/Overview/parts/ProductItem'
import { ProductItem as ProductItemType } from '@/features/common/components/Overview/parts/ProductItem/types'
import ActionButtons from '@/features/pos/components/Cart/parts/Overview/parts/CartItem/parts/ActionButtons'
import isEqual from 'lodash.isequal'
import { FC, memo } from 'react'

interface CartItemProps {
    productItem: ProductItemType
    onDelete: (id: string) => void
    onChangeQuantity: (id: string, changeQuantity: number) => void
    onEditAutomaticContainers: (id: string) => void
    hasAutomaticContainers: boolean
    expanded: boolean
    onToggle: () => void
    compact: boolean
}

const CartItem: FC<CartItemProps> = ({
    productItem,
    onDelete,
    onChangeQuantity,
    onEditAutomaticContainers,
    hasAutomaticContainers,
    expanded,
    onToggle,
    compact,
}) => {
    return (
        <ProductItem
            productItem={productItem}
            compact={compact}
            expanded={expanded}
            onToggle={onToggle}
            TailComponent={
                <ActionButtons
                    decreaseDisabled={productItem.quantity <= 1}
                    hasAutomaticContainers={hasAutomaticContainers}
                    id={productItem.id}
                    onDelete={onDelete}
                    onChangeQuantity={onChangeQuantity}
                    onEditAutomaticContainers={onEditAutomaticContainers}
                />
            }
            testID={`cart-item-${productItem.id}`}
        />
    )
}

export default memo(CartItem, isEqual)
